import { Component } from '@inter-ikea-core/core';
import { STATIC, MOVEABLE } from '../systems/AdaptAdjustableSystem';

export type IAdjustableState = typeof STATIC | typeof MOVEABLE;

/**
 * Component copied from S2 until we have moved over their code to this repo.
 */
export default class AdjustableStateComponent implements Component {
  static id = 3004;
  typeId: number = AdjustableStateComponent.id;
  doStoreInSnapshot: boolean = true;
  readonly serializable: boolean = false;

  constructor(readonly state: IAdjustableState) {}

  eq(_other: Component): boolean {
    return false;
  }
}
